// Api.
import api from '../Base';
import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const limit = process.env.REACT_APP_API_LIMIT;

const ActivityApi = {

    // Generic call — no limit/sort added (used when the caller controls all params)
    get: (endpoint: string, timeRangeQS: string, instanceId: number, params: string = '') =>
        api.get(`activity/${endpoint}?${timeRangeQS}&id=${instanceId}${params}`),

    getTime: (timeRangeQS: string, instanceId: number, params: string = '') =>
        api.get(`activity/time?${timeRangeQS}&id=${instanceId}${params}`),

    getSummary: (timeRangeQS: string, instanceId: number, params: string = '') =>
        api.get(`activity/summary?${timeRangeQS}&id=${instanceId}${params}`),

    // Standard list calls — include limit and sort
    getSql: (timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/sql?limit=${limit}&${timeRangeQS}&statistic=executions&sort=waittime+desc&id=${instanceId}${filterParams}`),

    getSqlGroup: (timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/sql/group?limit=${limit}&${timeRangeQS}&statistic=executions&sort=waittime+desc&id=${instanceId}${filterParams}`),

    getBatch: (timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/batch?limit=${limit}&${timeRangeQS}&sort=waittime+desc&id=${instanceId}${filterParams}`),

    getBatchGroup: (timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/batch/group?limit=${limit}&${timeRangeQS}&sort=waittime+desc&id=${instanceId}${filterParams}`),

    getWaitEvents: (timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/waitevent?limit=${limit}&${timeRangeQS}&sort=waittime+desc&id=${instanceId}${filterParams}`),

    // Generic dimension endpoint (database, session, client, program, username, etc.)
    getDimension: (dimension: string, timeRangeQS: string, instanceId: number, filterParams: string = '') =>
        api.get(`activity/${dimension}?limit=${limit}&${timeRangeQS}&sort=waittime+desc&id=${instanceId}${filterParams}`),

    // Archiver comparison fetch API (returns Promise<Response> for use with fetchResults)
    fetchSummary: (from: string, to: string, timezone: string, instanceId: number, interval: number, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/activity/summary?from=${from}&to=${to}&tz=${timezone}&id=${instanceId}&interval=${interval}${params}`),

    fetchSql: (from: string, to: string, timezone: string, instanceId: number, interval: number, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/activity/sql?from=${from}&to=${to}&tz=${timezone}&id=${instanceId}&interval=${interval}${params}`),

    fetchWaitEvents: (from: string, to: string, timezone: string, instanceId: number, interval: number, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/activity/waitevent?from=${from}&to=${to}&tz=${timezone}&id=${instanceId}&interval=${interval}${params}`),

    fetchTime: (from: string, to: string, timezone: string, instanceId: number, interval: number, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/activity/time?from=${from}&to=${to}&tz=${timezone}&id=${instanceId}&interval=${interval}${params}`),

    fetchById: (timeRangeQS: string): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/activity/id?limit=${process.env.REACT_APP_API_LIMIT}&${timeRangeQS}&sort=waittime+desc`),
};

export default ActivityApi;
